var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavAbout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0009 21.908C17.0258 21.908 21.91 17.0239 21.91 10.9989C21.91 4.97402 17.0258 0.0898438 11.0009 0.0898438C4.97596 0.0898438 0.0917969 4.97402 0.0917969 10.9989C0.0917969 17.0239 4.97596 21.908 11.0009 21.908ZM8.81907 5.54439C8.81907 4.33941 9.7959 3.36257 11.0009 3.36257C12.2059 3.36257 13.1827 4.33941 13.1827 5.54439C13.1827 6.74937 12.2059 7.72621 11.0009 7.72621C9.7959 7.72621 8.81907 6.74937 8.81907 5.54439ZM8.81907 10.4535C8.81907 9.85098 9.30749 9.36257 9.90998 9.36257H12.0918C12.6943 9.36257 13.1827 9.85098 13.1827 10.4535V16.4535C13.1827 17.056 12.6943 17.5444 12.0918 17.5444H9.90998C9.30749 17.5444 8.81907 17.056 8.81907 16.4535V10.4535Z",
    fill: "#5D688B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavAbout);
export default __webpack_public_path__ + "static/media/nav-about.43bf44f1.svg";
export { ForwardRef as ReactComponent };